import { Box, Typography } from '@mui/material'

import ToothIcon from '@/assets/images/fi-rs-tooth.png'
import PieChart from '@/components/PieChart'
import {
  ALL_IN_ONE_REGIONS,
  allInOneRecipeChart,
  getOpaquerAdvice,
} from '@/utils/matisseV2/allInOne'

type OpaquersEntity = {
  recipeOutput: any
}

const OpaquerRecipe = ({ recipeOutput }: OpaquersEntity) => {
  const renderPieChartSection = (title: string, labels: any, values: any) => {
    return (
      <Box
        sx={{
          background:
            'linear-gradient(133.84deg, #4e4e4e -16.04%, #333333 9.33%, #1a1a1a 32.02%, #1a1a1a 62.06%, #262626 87.42%, #4e4e4e 112.12%)',
          boxShadow: '2px 6px 15px 2px rgba(12, 10, 11, 0.8)',
          borderRadius: 2,
          height: '100%',
          margin: 'auto',
          width: '31%',
          aspectRatio: '284 / 340',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 2,
        }}
      >
        <Box display="flex" alignItems="center" margin={3} gap={2}>
          <Box
            component="img"
            src={ToothIcon}
            sx={{ height: '24px', width: '24px' }}
          />
          <Typography variant="h5" fontWeight="bold">
            {title}
          </Typography>
        </Box>

        <PieChart labels={labels} values={values} />
      </Box>
    )
  }

  const titles: Record<string, string> = {
    cervical: 'Cervical',
    middle: 'Middle',
    incisal: 'Incisal',
  }

  return (
    <Box display="flex" height="100%" paddingBottom={2}>
      {ALL_IN_ONE_REGIONS.map((region) => {
        const chart = allInOneRecipeChart(
          getOpaquerAdvice(recipeOutput, region),
        )
        if (!chart.labels.length) return null
        return (
          <Box key={region} display="contents">
            {renderPieChartSection(
              titles[region],
              chart.labels,
              chart.values as number[],
            )}
          </Box>
        )
      })}
    </Box>
  )
}

export default OpaquerRecipe
